import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Image from '@/commons/image';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import ListItemText from '@mui/material/ListItemText';
import {cn, translates} from '@/utils';
import { AvatarShape } from '@/commons/logo';
import { CustomAvatar } from '@/commons/custom-avatar';

type Props = {
    compact?: boolean;
    data: any;
    onClick: any;
    selected?: boolean;
};

export const CardBackground = ({ data, onClick, compact, selected }: Props) => (
    <Card sx={{ textAlign: 'center', cursor: 'pointer'}} className="hover:opacity-80 relative" onClick={() => onClick(data.id)}>
        <Box sx={{opacity: selected ? .3 : 0}} className={cn("absolute w-full h-full z-20 bg-black", {
            "border-green-500 border-2": selected
        })} />
        <Box sx={{ position: 'relative', backgroundImage: 'url("/assets/background/Background.jpeg")', backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
            <AvatarShape
                width={ compact ? 120: 144}
                height={62}
                sx={{
                    left: 0,
                    right: 0,
                    zIndex: 10,
                    mx: 'auto',
                    bottom: compact ? -30 : -26,
                    position: 'absolute',
                }}
            />
            <CustomAvatar
                sx={{
                    width: compact ? 46 : 64,
                    height: compact ? 46 : 64,
                    zIndex: 11,
                    left: 0,
                    right: 0,
                    bottom: compact ? -25 : -32,
                    mx: 'auto',
                    position: 'absolute',
                }}
                src={data?.photoURL}
                alt={data.name}
                name={data.name}
            />

            <Image ratio="16/9" />
        </Box>

        <ListItemText
            sx={{ mt: compact? 3 :7, mb: 1 }}
            primary={data.name}
            secondary={`NIT: ${data.nit}`}
            primaryTypographyProps={{ typography: 'subtitle1' }}
            secondaryTypographyProps={{ component: 'span', mt: 0.5 }}
        />

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Box display="flex" flexDirection="column" sx={{ py: compact ? 1.5 : 3, typography: 'subtitle1' }}>
            <div>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Stack
                        width={15}
                        height={15}
                        sx={{ backgroundColor: data.status ? 'green' : 'red', borderRadius: 10, marginRight: '5px' }}
                    />
                    <Typography
                        variant="overline"
                        component="div"
                        sx={{ mb: 0.5, color: 'text.primary' }}
                    >
                        {data.status ? translates.active : translates.inactive}
                    </Typography>
                </div>
            </div>
            <div>
                <Typography variant="caption" component="div" sx={{color: 'text.secondary' }}>
                    {`Tipo: ${data.typeBusiness}`}
                </Typography>
            </div>
        </Box>
    </Card>
);
